module.exports = __webpack_public_path__ + "build/img/warningrecom.a488f543.png";